<!--  -->
<template>
  <div class="section calendar">
    <div class="content" v-for="(item, k) in scheduleData" :key="k">
      <h1>
        <b>{{ item.nodesName }}</b>
      </h1>
      <div
        class="list"
        :class="{ first: n === 0, last: item.eventList.length === n + 1 }"
        v-for="(child, n) in item.eventList"
        :key="n"
      >
        <div class="left">{{ child.eventTime }}</div>
        <div class="right">
          <h3>{{ child.eventName }}</h3>
          <div class="richHtml" v-html="child.eventDesc"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { copyTool } from '@/utils/tools';

export default {
  components: {},
  data() {
    return {};
  },
  props: {
    scheduleData: {
      type: Array,
      default: () => [],
    },
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {
    document.body.addEventListener('click', (event) => {
      console.log(33333);
      event.stopImmediatePropagation();
      // 兼容处理
      const { target } = event;
      const parentNodeName = target.nodeName;
      // 判断是否匹配目标元素
      if (parentNodeName.toLocaleLowerCase() === 'a') {
        console.log(44444);
        // 对捕获到的 a 标签进行处理，需要先禁止它的跳转行为
        event.preventDefault();

        // 处理完 a 标签的内容，重新触发跳转，根据原来 a 标签页 target 来判断是否需要新窗口打开
        const url = target.getAttribute('href');
        copyTool(url)
          .then(() => {
            this.$toast('链接已复制，请到浏览器打开');
          })
          .catch(() => {
            this.$toast('复制失败');
          });
      }
    });
  },
};
</script>
<style lang="scss" scoped>
.section.calendar {
  .content {
    padding-bottom: 36px;
  }
}
.section {
  padding: 49px 36px 0 36px;
  .content:last-child {
    border-left: none;
  }
  .content {
    position: relative;
    box-sizing: border-box;
    padding-left: 47px;
    border-left: 4px dashed #e6e8ed;
    &::before {
      position: absolute;
      top: 0;
      left: -15px;
      width: 29px;
      height: 29px;
      background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/examPlan/dot.png')
        no-repeat;
      background-size: 100%;
      content: '';
    }
    h1 {
      display: flex;
      justify-content: space-between;
      padding-bottom: 14px;
      b {
        color: #333;
        font-weight: 600;
        font-size: 29px;
      }
      span {
        color: #999;
        font-weight: 400;
        font-size: 25px;
      }
    }
    .box {
      width: 100%;
      margin-bottom: 36px;
      padding: 22px;
      background: #f9fafd;
      border-radius: 14px;
      > h2 {
        padding-bottom: 22px;
        color: #333;
        font-weight: 400;
        font-size: 25px;
      }
      > p {
        color: #999;
        font-weight: 400;
        font-size: 22px;
        line-height: 33px;
      }
    }
    .list.first {
      .left {
        border-top: none;
        border-top-left-radius: 14px;
      }
      .right {
        border-top: none;
      }
    }
    .list.last {
      .left {
        border-bottom-left-radius: 14px;
      }
    }
    .list {
      display: flex;
      width: 630px;
      min-height: 80px;
      background: #f9fafd;
      border-radius: 14px;
      .left {
        display: flex;
        flex-shrink: 0;
        align-content: center;
        align-items: center;
        justify-content: center;
        width: 178px;
        min-height: 80px;
        padding: 11px;
        color: #ff7f41;
        font-weight: 500;
        font-size: 25px;
        line-height: 36px;
        text-align: center;
        word-break: break-all;
        background: #fff3ee;
        border-top: 1px solid #fff;
        // border-radius: 14px 0 0 14px;
      }
      .right {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        width: 100%;
        padding: 22px 0 22px 14px;
        border-top: 1px solid #e6e7e9;
        h3 {
          width: 100%;
          color: #333;
          font-weight: 400;
          font-size: 25px;
          word-break: break-all;
        }
        .richHtml {
          padding-top: 14px;
          color: #999;
          font-weight: 400;
          font-size: 22px;
          line-height: 31px;
          ::v-deep a {
            color: #6191F2;
          }
        }
      }
    }
  }
}
</style>
